import angular from 'angular';

angular.module('app.docrepo_invoice').component('docrepoInvoiceEvents', {
  templateUrl: require('./events.html'),
  bindings: {
    events: '<', // Evenement de la facture
    type: '@' // Type d'évènement
  }
});
